import { ServiceRoutesConfig, ServiceRoutesContainer } from './serviceroute.models'

export const serviceRoutesContainer: ServiceRoutesContainer = {
  hmr: {
    projectWebBaseUrl: 'https://localhost:4200/',
    microsoftGraphBaseUrl: 'https://graph.microsoft.com'
  } as ServiceRoutesConfig,
  dev: {
    projectWebBaseUrl: 'https://localhost:4200/', //to reconfigure - the dev config is using on test env
    //projectWebBaseUrl: 'https://vouchers-ui.villaplustest.com/',
    microsoftGraphBaseUrl: 'https://graph.microsoft.com'
  } as ServiceRoutesConfig,
  test: {
    projectWebBaseUrl: 'https://vouchers-ui.villaplustest.com/',
    microsoftGraphBaseUrl: 'https://graph.microsoft.com'
  } as ServiceRoutesConfig,
  production: {
    projectWebBaseUrl: 'https://vouchers-ui.villaplus.com/',
    microsoftGraphBaseUrl: 'https://graph.microsoft.com'
  } as ServiceRoutesConfig

} as ServiceRoutesContainer;
